module.exports = __webpack_public_path__ + "img/money-box.d57636b0.png";